<div class="row">
  <div class="col-md-10 col-10">
    <h3 mat-dialog-title >{{  'EditPayment' | translate  }}</h3>
  </div>
  <div class="col-md-2 col-2 p-0">
      <button mat-dialog-action class="btnLink closeModal text-right" (click)="close()"> <fa-icon [icon]="faTimesCircle"></fa-icon></button>
  </div>
</div>
 
<mat-dialog-content>

  <div class="row mt-3 add-payment-modal">
    <div class="col-md-12">
      <form name="form" [formGroup]="form" (ngSubmit)="form.valid && onSubmit()">
        <div class="form-group row">
          <label class="col-form-label col-md-4" for="customerName">{{  'CustomerName' | translate  }}</label>
          <div class="col-md-8">
            <input placeholder="{{  'Pleasedefine' | translate  }}" type="text"  class="form-control" formControlName="customerName" [ngClass]="{'is-invalid':form.get('customerName').touched && form.get('customerName').invalid}" required />
           
          </div>
        </div>
        <div class="form-group row">
          <label class="col-form-label col-md-4" for="cardNo">{{  'CardNumber' | translate  }}</label>
          <div class="col-md-8">
            <input placeholder="{{  'Pleasedefine' | translate  }}" type="number" class="form-control" formControlName="cardNo" [ngClass]="{'is-invalid':form.get('cardNo').touched && form.get('cardNo').invalid}" required />
           
          </div>
        </div>
        <div class="form-group row">
          <label class="col-form-label col-md-4" for="securityCode">{{  'SecurityCode' | translate  }}</label>
          <div class="col-md-8">
            <input placeholder="{{  'Pleasedefine' | translate  }}" type="number" class="form-control" formControlName="securityCode" [ngClass]="{'is-invalid':form.get('securityCode').touched && form.get('securityCode').invalid}" required />
           
          </div>
        </div>

        <div class="form-group row">
          <label class="col-form-label col-md-4" for="expiryDate">{{  'ExpiryDate' | translate  }}</label>
          <div class="col-md-4 pr-md-0">
            <input placeholder="mm" type="number" class="form-control" formControlName="expiryDateMonth" [ngClass]="{'is-invalid':form.get('expiryDateMonth').touched && form.get('expiryDateMonth').invalid}" required />
          
          </div>
          <div class="col-md-4">
            <input placeholder="yy" type="number" class="form-control" formControlName="expiryDateYear" [ngClass]="{'is-invalid':form.get('expiryDateYear').touched && form.get('expiryDateYear').invalid}" required />
            
          </div>
        </div> 
 
        <div class=" row mt-4">
          <div class="col-md-4"></div>
          <div class="col-md-8">
            <button class="btn default-btn mr-3" [disabled]="!form.valid" mat-button>{{ 'Confirm' | translate }}</button>
            <button (click)="close()" class="btn default-cancel-btn" mat-button>{{ 'Cancel' | translate }}</button>
          </div>
        </div>
      </form>


    </div>

  </div>

</mat-dialog-content>
